<template>
  <div class="plv-ia-lottery-countdown">
    <slot :countdown="calcDelay"></slot>
  </div>
</template>

<script>
export default {
  name: 'countDown',
  props: {
    delayTime: {
      type: Number,
      default: 0
    }
  },
  watch: {
    delayTime: {
      handler(val) {
        this.countdownTime = Math.floor(val / 1000);
        this.initTimer();
      },
      immediate: true
    }
  },
  data() {
    return {
      countdownTime: 0,
      timer: null
    };
  },
  computed: {
    calcDelay() {
      const time = Math.floor(this.countdownTime);
      let hour = 0;
      let min = 0;
      let second = 0;

      if (time > 60) {
        // 是否大于零
        min = Math.floor(time / 60); // 分钟
        second = Math.floor(time % 60); // 秒
        if (min > 60) {
          hour = Math.floor(min / 60);
          min = Math.floor(min % 60);
        }
      } else if (time > 0) {
        second = time;
      }
      return {
        hour: hour > 9 ? hour : '0' + hour,
        min: min > 9 ? min : '0' + min,
        second: second > 9 ? second : '0' + second
      };
    }
  },
  methods: {
    initTimer() {
      if (this.timer) clearInterval(this.timer);
      let oldDate = new Date().getTime();
      this.timer = setInterval(() => {
        const newDate = new Date().getTime();
        const diffDate = Math.round((newDate - oldDate) / 1000);
        if (this.countdownTime < 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.$emit('countdown-finish');
        } else {
          this.countdownTime = this.countdownTime - diffDate;
          oldDate = newDate;
        }
      }, 1000);

    }
  }
};
</script>
